<template>
    <div>
        <ValidationObserver v-slot="{ handleSubmit, invalid }">
            <b-form @submit.prevent="handleSubmit(handleStore)"> 
                <b-card header-tag="header" footer-tag="footer" class="mt-8 mb-8">
                    <template v-slot:header>
                        <p class="mb-0" style="font-size: 21px"><b>Registro Compañia</b></p>
                    </template>
                    <b-card-text>
                        <b-alert show variant="danger" v-if="errores">
                            <ul >
                                <li v-for="(item, index) in errors" :key="index">{{ item[0] }}</li>
                            </ul>
                        </b-alert>
                        <b-row>
                            <b-col cols="12" md="4">
                                <ValidationProvider name="Nit de la compañia"  rules="required|min:3" v-slot="{ errors, valid }">
                                    <b-form-group 
                                        label="Nit:"
                                        label-for="formDataCompanyNit">
                                        <b-form-input
                                            id="formDataCompanyNit"
                                            v-model="formData.nit"
                                            type="text"
                                            autocomplete="off"
                                            required
                                            disabled
                                            :state="errors[0] ? false : (valid ? true : null)"
                                            placeholder="Ingrese el nit"
                                            ></b-form-input>
                                        <b-form-invalid-feedback>
                                            {{ errors[0] }}
                                        </b-form-invalid-feedback>
                                    </b-form-group>
                                </ValidationProvider>
                            </b-col>
                            <b-col cols="12" md="8">
                                <ValidationProvider name="Nombre de la compañia"  rules="required|min:3" v-slot="{ errors, valid }">
                                    <b-form-group 
                                        label="Nombre:"
                                        label-for="formDataCompanyName">
                                        <b-form-input
                                            id="formDataCompanyName"
                                            v-model="formData.name"
                                            type="text"
                                            autocomplete="off"
                                            required
                                            disabled
                                            :state="errors[0] ? false : (valid ? true : null)"
                                            placeholder="Ingrese el nombre"
                                            ></b-form-input>
                                        <b-form-invalid-feedback>
                                            {{ errors[0] }}
                                        </b-form-invalid-feedback>
                                    </b-form-group>
                                </ValidationProvider>
                            </b-col>
                        </b-row>
                        <b-row>
                            <b-col cols="12" md="12">
                                <ValidationProvider name="Email del contacto"  rules="required" v-slot="{ errors, valid }">
                                    <b-form-group 
                                        label="Email:"
                                        label-for="formDataCompanyEmail">
                                        <b-form-input
                                            id="formDataCompanyEmail"
                                            v-model="formData.email"
                                            type="text"
                                            autocomplete="off"
                                            required
                                            :state="errors[0] ? false : (valid ? true : null)"
                                            placeholder="Ingrese el email"
                                            ></b-form-input>
                                        <b-form-invalid-feedback>
                                            {{ errors[0] }}
                                        </b-form-invalid-feedback>
                                    </b-form-group>
                                </ValidationProvider>
                            </b-col>
                        </b-row>
                    </b-card-text>
                    <template v-slot:footer>
                        <b-button variant="danger" class="mr-2" @click.prevent="back">
                            Cancelar
                        </b-button>
                        <b-button variant="success" :disabled="invalid" type="submit">
                            Registrar
                        </b-button>
                    </template>
                </b-card>
            </b-form>
        </ValidationObserver>
    </div>
</template>

<script>
import { ValidationProvider } from 'vee-validate';
import { mapMutations } from 'vuex'
export default {
    name: 'ChatbotInvitationRegister',

    data() {
        return {
            saving: false,
            formData: {
                nit:          this.$route.params.company?.nit   || '',
                name:         this.$route.params.company?.name  || '',
                email:        this.$route.params.company?.email || '',
                lookup_token: this.$route.params.lookupToken    || '',
            },
            errors: {},
            errores: false,
        }
    },
    components: {
        ValidationProvider
    },

    methods: {
        ...mapMutations(['setLoading']),
        back(){
            this.$router.go(-1);
        },
        async handleStore() {
            this.errors = {};
            this.errores = false;
            this.setLoading(true)
            await this.$conectar.post('/admin/chatbot-invitations/store', this.formData)
            .then(response=>{
                if(response.data.error == true){
                    this.errores = true;
                    this.errors = response.data.errors;
                }else{
                    this.$root.$bvToast.toast(response.data.message, {
                        title: "Respuesta del servidor",
                        variant: "success",
                        solid: true
                    })
                    this.$router.push({ name: 'chatbot-invitations.index' });
                }
            })
            .catch(response =>{
                console.log(response);
                this.$root.$bvToast.toast("Error en el servidor, favor intente nuevamente mas tarde", {
                    title: "Respuesta del servidor",
                    variant: "danger",
                    solid: true
                })
            })
            this.setLoading(false)
        }
    }
}
</script>